import React, { useState } from "react";
import InvalidMessage from "venuescanner-js/react/components/Form/Notifications/InvalidMessage";
import placeholders from "venuescanner-js/react/components/Form/copy/placeholders";
import classes from "./Input.module.scss";
import {
  IconEyeHide,
  IconEye,
} from "venuescanner-js/react/components/Objects/Icons/IconEye.js";
import cl from "classnames";

function Input(props) {
  const {
    errors = {},
    touched = {},
    label,
    name,
    register,
    value,
    handleChange,
    disabled,
    autocomplete,
  } = props;
  const [type, setType] = useState("password");
  return (
    <div
      className={cl([
        classes.input,
        { "form-error": errors[name] && (!touched || touched[name]) },
      ])}
    >
      {label && <label>{label}</label>}
      <div className={classes["password-row"]}>
        <input
          name={name}
          ref={register}
          placeholder={placeholders[name]}
          onChange={(e) => {
            handleChange(e);
          }}
          type={type}
          disabled={disabled}
          autoComplete={autocomplete}
          defaultValue={value || ""}
        />
        <span className={classes["show-password"]}>
          {type === "password" ? (
            <IconEye
              handleClick={() => {
                setType("text");
              }}
            />
          ) : (
            <IconEyeHide
              handleClick={() => {
                setType("password");
              }}
            />
          )}
        </span>
      </div>
      <InvalidMessage error={(!touched || touched[name]) && errors[name]} />
    </div>
  );
}

export default Input;
